import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../services/http/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { GoogleSigninButtonDirective } from '../../directives/google-signin-button.directive';

/**
 * This component handles logging in with Google.
 */
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less'],
    imports: [GoogleSigninButtonDirective]
})
export class LoginComponent implements OnInit {
  private authService = inject(AuthService);
  private toastr = inject(ToastrService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /**
   * Logins with Single sign-on, and then sends request to backend to authenticate.
   */
  ngOnInit() {
    this.authService.loginSso()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (socialUser) => {
          if (socialUser !== null) {
            this.authService.login(socialUser)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: () => this.router.navigate(['/']),
                error: (error) => this.toastr.error(error)
              });
          }
        }
      });
  }
}
